import type { GQL_ID } from '@@partner:types:graphql'
import type { Menu, MenuType } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

export interface CreateMenuInput {
  name: string
  code: string
  type: MenuType
  is_active?: boolean
}

export interface CreateMenuMutation {
  createMenu: Menu
}

export interface CreateMenuVariables {
  input: CreateMenuInput
}

export const GQL_MUTATION_CREATE_MENU = gql`
  mutation createMenu($input: CreateMenuInput!) {
    createMenu(input: $input) {
      id
      name
      code
      type
      is_active
      created_at
      updated_at
    }
  }
`

export const useCreateMenu = () =>
  useMutation<CreateMenuMutation, CreateMenuVariables>(GQL_MUTATION_CREATE_MENU)
